import { Area } from './SearchSuggestionsTownsAndCities.types';

export const defaultForSaleAreas: Area[] = [
    {
        id: 'in-the-city',
        headline: 'In the city',
        sub_headline: 'Live among the hustle and bustle',
        items: [
            {
                location: 'london',
                headline: 'London properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/london/'
            },
            {
                location: 'leeds',
                headline: 'Leeds properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/west-yorkshire/leeds/'
            },
            {
                location: 'edinburgh',
                headline: 'Edinburgh properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/edinburgh/'
            },
            {
                location: 'manchester',
                headline: 'Manchester properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/manchester/'
            },
            {
                location: 'liverpool',
                headline: 'Liverpool properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/liverpool/'
            },
            {
                location: 'cardiff',
                headline: 'Cardiff properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/cardiff/'
            }
        ]
    },
    {
        id: 'on-the-coast',
        headline: 'On the coast',
        sub_headline: 'Wake up to fresh air and sea views',
        items: [
            {
                location: 'swansea',
                headline: 'Swansea properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/swansea/'
            },
            {
                location: 'bristol',
                headline: 'Bristol properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/bristol/'
            },
            {
                location: 'hull',
                headline: 'Hull properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/hull/'
            },
            {
                location: 'southampton',
                headline: 'Southampton properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/southampton/'
            },
            {
                location: 'plymouth',
                headline: 'Plymouth properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/plymouth/'
            },
            {
                location: 'dundee',
                headline: 'Dundee properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/dundee/'
            }
        ]
    },
    {
        id: 'rural-and-countryside',
        headline: 'Rural and countryside',
        sub_headline: 'Enjoy living close to nature',
        items: [
            {
                location: 'leicester',
                headline: 'Leicester properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/leicester/'
            },
            {
                location: 'northampton',
                headline: 'Northampton properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/northampton/'
            },
            {
                location: 'kent',
                headline: 'Kent properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/kent/'
            },
            {
                location: 'cornwall',
                headline: 'Cornwall properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/cornwall/'
            },
            {
                location: 'essex',
                headline: 'Essex properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/essex/'
            },
            {
                location: 'devon',
                headline: 'Devon properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/devon/'
            }
        ]
    },
    {
        id: 'popular-locations',
        headline: 'Popular locations',
        sub_headline: 'Move to a property hotspot',
        see_all_property: {
            link: 'https://www.zoopla.co.uk/for-sale/property/uk/',
            text: 'See all UK properties for sale'
        },
        items: [
            {
                location: 'glasgow',
                headline: 'Glasgow properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/glasgow/'
            },
            {
                location: 'birmingham',
                headline: 'Birmingham properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/birmingham/'
            },
            {
                location: 'nottingham',
                headline: 'Nottingham properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/nottingham/'
            },
            {
                location: 'sheffield',
                headline: 'Sheffield properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/sheffield/'
            },
            {
                location: 'coventry',
                headline: 'Coventry properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/coventry/'
            },
            {
                location: 'stoke-on-trent',
                headline: 'Stoke-on-Trent properties for sale',
                url: 'https://www.zoopla.co.uk/for-sale/property/stoke-on-trent/'
            }
        ]
    }
];
